import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { HeartHandshake, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LangContext";
import { ACCOUNT_UI as UI } from "@/data/accountI18n";
import { SupporterBadge } from "@/components/support/SupporterBadge";
import { isPlayStoreApp } from "@/lib/apkVersion";

// Compact "Dukung Manasik" CTA. Supporters see a thank-you row instead (or nothing when showStatus=false).
export const SupportHomeCard = ({ showStatus = false }) => {
  const { user } = useAuth();
  const { tc } = useLang();
  if (isPlayStoreApp() || (user?.supporter && !showStatus)) return null;
  const supporter = !!user?.supporter;
  return (
    <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }}>
      <Card className="rounded-3xl border-[hsl(var(--gold))]/40 bg-[hsl(var(--gold))]/5 shadow-sm p-5 flex flex-col sm:flex-row sm:items-center gap-4"
        data-testid="support-home-card" data-supporter={supporter}>
        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-[hsl(var(--gold))]/20 text-[hsl(var(--gold))]"><HeartHandshake className="h-6 w-6" /></span>
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2">
            <p className="font-medium">{supporter ? tc(UI.thanksBody).split(".")[0] : tc(UI.homeTitle)}</p>
            {supporter && <SupporterBadge />}
          </div>
          <p className="text-xs text-muted-foreground mt-0.5">{supporter ? tc(UI.freeNote) : tc(UI.homeHint)}</p>
        </div>
        <Link to="/support" data-testid="support-home-cta">
          <Button className={supporter ? "h-10 rounded-full px-5 bg-transparent border border-border text-foreground hover:bg-muted" : "h-10 rounded-full px-5 bg-[hsl(var(--gold))] text-black hover:bg-[hsl(var(--gold))]/90"}>
            {supporter ? tc(UI.supportTitle) : tc(UI.homeCta)}<ArrowRight className="ms-2 h-4 w-4 rtl:rotate-180" />
          </Button>
        </Link>
      </Card>
    </motion.div>
  );
};
